import React from 'react'
import { SimpleShowLayout } from 'react-admin'
import { EventItem } from 'services/api/entities/events/types/internal/event-models'
import { getGeoLang } from 'services/geo-management'
import { useKRecordContext } from 'services/hooks/useKRecordContext'
import { optionsWithTime } from 'services/utils/date'
import LabeledDateField from 'ui-shared/LabeledFields/LabeledDateField'
import LabeledTextField from 'ui-shared/LabeledFields/LabeledTextField'

const EventEditReadonlyFields: React.FC = () => {
  const record = useKRecordContext<EventItem>()

  return (
    <SimpleShowLayout>
      <div style={{ display: 'flex', gap: '32px' }}>
        <LabeledTextField source="name" label="form.fields.name" />
        <LabeledDateField
          label="form.fields.createdAt"
          source="createdAt"
          locales={getGeoLang()}
          options={optionsWithTime}
        />
        {!!record?.storeUpdatedAt && (
          <LabeledDateField
            label="form.fields.storeUpdatedAt"
            source="storeUpdatedAt"
            locales={getGeoLang()}
            options={optionsWithTime}
          />
        )}
        <LabeledTextField
          source="customerInfo.name"
          label="form.fields.customer"
        />
        <LabeledTextField
          source="customerInfo.responsibleFullName"
          label="form.fields.responsibleFullName"
        />
        <LabeledTextField
          source="customerInfo.email"
          label="form.fields.email"
        />
        <LabeledTextField
          source="customerInfo.phone"
          label="form.fields.phone"
        />
        <LabeledTextField
          source="purchasedServices"
          label="form.fields.purchasedServices"
        />
      </div>
    </SimpleShowLayout>
  )
}

export default EventEditReadonlyFields
